<section class="collector-list" aria-label="Collectors">
  <div *ngIf="loading" class="list-state" role="status">Loading availability…</div>
  <div *ngIf="!loading && error" class="list-state error-state" role="alert">{{ error }}</div>
  <div *ngIf="!loading && !error && rows.length === 0" class="list-state">
    {{ availabilityFilter === 'all'
      ? 'No collectors match the selected filters.'
      : availabilityFilter === 'notSubmitted'
        ? 'No collectors with unsubmitted availability match the selected filters.'
      : availabilityFilter === 'freeForEntirePeriod'
        ? 'No collectors are free for the entire selected period.'
        : 'No collectors are free during the selected period.' }}
  </div>
  <ng-container *ngIf="!loading && !error">
    <app-collector-availability-row
      *ngFor="let row of rows"
      [row]="row"
      [selectedFromMinute]="selectedFromMinute"
      [selectedToMinute]="selectedToMinute"
      [clearPinnedTick]="clearPinnedTick"
      (pinnedChange)="pinnedChange.emit($event)"
    ></app-collector-availability-row>
    <mat-paginator
      [length]="count"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      [showFirstLastButtons]="true"
      (page)="onPageChange($event)"
    ></mat-paginator>
  </ng-container>
  <div
    *ngIf="
      !loading &&
      !error &&
      availabilityFilter !== 'all' &&
      availabilityFilter !== 'notSubmitted'
    "
    class="unavailable-summary"
  >
    {{ unavailableCount }}
    {{ availabilityFilter === 'freeForEntirePeriod' ? 'not free for entire period' : 'unavailable in period' }}
  </div>
</section>
